import { render } from "./NetworkError.vue?vue&type=template&id=cdf8953c"
const script = {}
script.render = render

export default script